import PropTypes from 'prop-types';
import classNames from 'classnames';

import './LandingSection.scss';

const LandingSection = ({
  className = '',
  children,
  containerClassName = ''
}) => (
  <section className={classNames('landing-section', className)}>
    <div
      className={classNames('landing-section__container', containerClassName)}
    >
      {children}
    </div>
  </section>
);

LandingSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  containerClassName: PropTypes.string
};

export default LandingSection;
